import * as joint from '@joint/core'

/**
 * C4 Folder shape - folder icon with tab
 */
export const C4Folder = joint.dia.Element.define(
  'c4.Folder',
  {
    size: { width: 240, height: 160 },
    attrs: {
      tab: {
        refX: 0,
        refY: 0,
        refWidth: '40%',
        height: 20,
        rx: 5,
        ry: 5,
        fill: '#438dd5',
        stroke: '#2e6295',
        strokeWidth: 2,
      },
      body: {
        refX: 0,
        refY: 15,
        refWidth: '100%',
        refHeight: 'calc(h - 15)',
        rx: 5,
        ry: 5,
        fill: '#438dd5',
        stroke: '#2e6295',
        strokeWidth: 2,
      },
      nameLabel: {
        refX: '50%',
        refY: 50,
        textVerticalAnchor: 'middle',
        textAnchor: 'middle',
        fontSize: 14,
        fontWeight: 'bold',
        fill: '#ffffff',
        fontFamily: 'Open Sans, sans-serif',
        text: '',
      },
      typeLabel: {
        refX: '50%',
        refY: 70,
        textVerticalAnchor: 'middle',
        textAnchor: 'middle',
        fontSize: 11,
        fill: '#ffffff',
        fontFamily: 'Open Sans, sans-serif',
        text: '[Folder]',
      },
      descriptionLabel: {
        refX: '50%',
        refY: 95,
        textVerticalAnchor: 'top',
        textAnchor: 'middle',
        fontSize: 11,
        fill: '#ffffff',
        fontFamily: 'Open Sans, sans-serif',
        text: '',
        textWrap: {
          width: '90%',
          height: 50,
          ellipsis: true,
        },
      },
    },
  },
  {
    markup: [
      { tagName: 'rect', selector: 'tab' },
      { tagName: 'rect', selector: 'body' },
      { tagName: 'text', selector: 'nameLabel' },
      { tagName: 'text', selector: 'typeLabel' },
      { tagName: 'text', selector: 'descriptionLabel' },
    ],
  }
)

export function createFolder(
  id: string,
  name: string,
  technology: string = '',
  description: string = '',
  x: number = 0,
  y: number = 0,
  style?: {
    background?: string
    stroke?: string
    color?: string
  }
): joint.dia.Element {
  const typeText = technology ? `[Folder: ${technology}]` : '[Folder]'

  const folder = new C4Folder({
    id,
    position: { x, y },
    attrs: {
      tab: {
        ...(style?.background && { fill: style.background }),
        ...(style?.stroke && { stroke: style.stroke }),
      },
      body: {
        ...(style?.background && { fill: style.background }),
        ...(style?.stroke && { stroke: style.stroke }),
      },
      nameLabel: {
        text: name,
        ...(style?.color && { fill: style.color }),
      },
      typeLabel: {
        text: typeText,
        ...(style?.color && { fill: style.color }),
      },
      descriptionLabel: {
        text: description,
        ...(style?.color && { fill: style.color }),
      },
    },
  })

  return folder
}
